import { find } from 'lodash';

const selectedWordId = (state) => {
  const selectedCells = state.gridSettings.selectedCells

  if (!selectedCells.length) {
    return null
  }

  return selectedCells[0].word_id
}

const correctNextCell = (state, getters) => {
  const selectedCells = state.gridSettings.selectedCells

  if (!selectedCells.length) {
    return null
  }

  const selectedCellIds = selectedCells.map(item => item.id)
  const word_id = getters.selectedWordId
  const word = find(state.currentPuzzle.words, item => item.id === word_id)
  const correctCellChain = word.cells.map(item => item.id).slice(0, selectedCellIds.length)

  if (word.is_bonus || JSON.stringify(selectedCellIds) !== JSON.stringify(correctCellChain) || selectedCells.length === word.cells.length) {
    return null
  }

  return word.cells[selectedCellIds.length]
}

const allNonBonusWordsFound = (state) => {
  const puzzle = state.currentPuzzle
  if (!puzzle || !puzzle.id) {
    return false
  }

  return state.foundWordIds.length === puzzle.words.length - 1
}

const puzzleSolved = (state) => {
  const puzzle = state.currentPuzzle
  if (!puzzle || !puzzle.id) {
    return false
  }

  return state.foundWordIds.length === puzzle.words.length
}

const selectedChars = (state) => {
  return state.gridSettings.selectedCells.map(item => item.char).join('').toUpperCase()
}

const puzzleTimerId = (state) => {
  const puzzle = state.currentPuzzle
  if (!puzzle || !puzzle.id) {
    return false
  }

  return `puzzle_timer_${puzzle.id}`
}

const textByRealm = (state) => ({ realm }) => {
  return find(state.texts, item => item.realm === realm)
}

export default {
  selectedWordId,
  correctNextCell,
  allNonBonusWordsFound,
  puzzleSolved,
  selectedChars,
  puzzleTimerId,
  textByRealm
}
